export const getters = {
  socialMediaList: (state) => state.socialMediaList,
};
